export const fetchAdBlockTestFile = (): Promise<Response> => {
    return fetch("/abdetect.js", {
        method: "GET",
        headers: {
            "Content-Type": "application/json;charset=UTF-8",
        },
    });
};
